import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SID_KEY = 'krug-analytics-sid';
const CONSENT_KEY = 'krug-cookie-consent';
const API = process.env.REACT_APP_BACKEND_URL;

const getSessionId = () => {
  let sid = localStorage.getItem(SID_KEY);
  if (!sid) {
    sid = crypto.randomUUID();
    localStorage.setItem(SID_KEY, sid);
  }
  return sid;
};

export const track = (type, data = {}) => {
  if (localStorage.getItem(CONSENT_KEY) !== 'all') return;
  const payload = JSON.stringify({
    type,
    path: window.location.pathname,
    session: getSessionId(),
    lang: localStorage.getItem('krug-lang') || 'bs',
    ...data,
  });
  fetch(`${API}/api/analytics/event`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: payload,
    keepalive: true,
  }).catch(() => {});
};

export const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    track('pageview');
  }, [location.pathname]);

  useEffect(() => {
    const onClick = (e) => {
      const el = e.target.closest('[data-testid]');
      if (el) track('click', { element: el.getAttribute('data-testid') });
    };
    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, []);
};
